import { styled } from "linaria/react";

// Styled container with top and bottom borders
export const SrtDispatchContainer = styled.div<{ darkMode: boolean }>`
  width: 100%;
  max-width: 100%;
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-top-color: ${(props) => (props.darkMode ? "#3E4245" : "#E6EAEB")};
  border-bottom-color: ${(props) => (props.darkMode ? "#3E4245" : "#E6EAEB")};
  padding: 10px 15px;
  font-family: Montserrat, sans-serif;
  animation: colorize 1s linear;

  @keyframes colorize {
    0% {
      background-color: #cee6c1;
    100% {
      background-color:${(props) => (props.darkMode ? "#282B36" : "#ffffff")};
    }
  }
`;

// Top row: "DISPATCH" label + time on the right
export const SrtTopRow = styled.div<{ darkMode: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
`;

// Light gray "DISPATCH" text
export const SrtLabel = styled.div<{ darkMode: boolean }>`
  font-size: 12px;
  text-transform: uppercase;
  color: ${(props) => (props.darkMode ? "#8D8F93" : "#96A3AA")};
  font-weight: bold;
`;

// Right side: Icon + Time
export const SrtTimeWrapper = styled.div<{ darkMode: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: ${(props) => (props.darkMode ? "#8D8F93" : "#96A3AA")};
`;

// Main message in bold
export const SrtMessage = styled.div<{ darkMode: boolean }>`
  font-size: 16px;
  color: ${(props) => (props.darkMode ? "#C4C4C4" : "#506873")};
`;

// Replay button
export const SrtReplayButton = styled.button<{ darkMode: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: ${(props) => (props.darkMode ? "#B2B9C0" : "#59717B")};

  svg {
    width: 20px;
    height: auto;
    stroke-width: 1; /* Ensures the stroke remains visible */
  }
`;
